import React, { useEffect } from 'react';
import styles from './noteDialog.module.scss';
import { useForm } from 'react-hook-form';
import TextArea from '../../../../../../../../Components/Inputs/TextArea/textArea';
import Button from '../../../../../../../../Components/Button/button';
import { ButtonTypes } from '../../../../../../../../Interfaces/componentTypes';
import { useTranslation } from 'react-i18next';

interface IProps {
  note?: string,
  onHandleNote: (note: string) => void
}

const NoteDialog: React.FC<IProps> = ({ note, onHandleNote }) => {
  const { register, getValues, setValue } = useForm<{ notes: string }>();
  const { t } = useTranslation();

  useEffect(() => {
    note && setValue('notes', note)
  }, []);


  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p>{t('Visitor.Delivery.Note_Label')}</p>
      </div>
      <TextArea
        register={register}
        registerName='notes'
        style={styles.textArea}
        defaultValue={note}
        rows={5}
      />
      <div className={styles.buttonsRow}>
        <Button
          buttonType={ButtonTypes.Secondary}
          title={t('Buttons.Cancel')}
          onClick={() => onHandleNote('')}
          buttonStyle={styles.buttons}
          buttonTitleStyle={styles.buttonsTitle}
        />
        <Button
          buttonType={ButtonTypes.Primery}
          title={t('Buttons.Save')}
          onClick={() => onHandleNote(getValues('notes'))}
          buttonStyle={styles.buttons}
          buttonTitleStyle={styles.buttonsTitle}
        />
      </div>
    </div>
  )
}

export default NoteDialog
